import type { OrdenServicioConRelaciones } from '@/modules/ordenes-servicio/tipos'
import { pesos } from '@/shared/utilidades/formato'

import { fuenteDeLaOrden } from './fuenteDeLaOrden'
import { useHojaCotizacion } from './useHojaCotizacion'
import estilos from './ResumenDeLaCotizacion.module.css'

/**
 * QUÉ SE ESTÁ APROBANDO, EN LA MISMA TARJETA.
 *
 * Primero esto fue un botón que abría el documento. Johan: «por qué no se
 * expande ahí la cotización, por qué tengo que abrirla». Y es el mismo
 * problema de antes con un paso menos: si hay que pulsar algo para ver qué se
 * aprueba, se aprueba sin pulsarlo.
 *
 * Así que los renglones están puestos, sin abrir nada. Lo que se lee aquí es
 * lo que se decide: cuánto de qué, y el total abajo. La hoja completa —con el
 * membrete, los datos del cliente y el IVA renglón por renglón— sigue estando
 * para quien la necesite en papel; esto no la reemplaza, la adelanta.
 *
 * SALE DE LA MISMA CONSULTA QUE LA HOJA. No se vuelve a sumar nada aquí: los
 * totales son los que ya calculó `useHojaCotizacion` con las reglas de World
 * Office —el IVA por unidad se redondea, los importes se truncan—. Dos sumas
 * distintas del mismo documento serían dos verdades.
 */
export function ResumenDeLaCotizacion({ orden }: { orden: OrdenServicioConRelaciones }) {
  const { data, isLoading } = useHojaCotizacion(fuenteDeLaOrden(orden))

  if (isLoading) return <p className={estilos.esperando}>Trayendo los renglones…</p>
  if (!data || data.lineas.length === 0) return null

  return (
    <div className={estilos.resumen}>
      {/* SE DICE CUÁNTOS SON. La lista rueda por dentro —con veinte renglones
          el botón de aprobar se iría fuera de la pantalla— y una lista que
          rueda sin avisar parece completa: se aprueba creyendo que se vio
          todo. El número de arriba es lo que desmiente eso. */}
      <p className={estilos.cuantos}>
        {data.lineas.length === 1 ? '1 renglón' : data.lineas.length + ' renglones'}
      </p>

      <ul className={estilos.lineas}>
        {data.lineas.map((l, i) => (
          <li key={i} className={estilos.linea}>
            <span className={estilos.cantidad}>
              {l.cantidad} {l.unidad ?? 'Und.'}
            </span>
            <span className={estilos.descripcion}>{l.descripcion}</span>
            <span className={estilos.importe}>{pesos(l.total)}</span>
          </li>
        ))}
      </ul>

      <dl className={estilos.totales}>
        <div>
          <dt>Subtotal</dt>
          <dd>{pesos(data.subtotal)}</dd>
        </div>
        <div>
          <dt>IVA</dt>
          <dd>{pesos(data.iva)}</dd>
        </div>
      </dl>
    </div>
  )
}
